// extracted by mini-css-extract-plugin
module.exports = {"disclaimer-container":"Disclaimer_disclaimer-container__RXVjb","disclaimer":"Disclaimer_disclaimer___FYrW"};